import ApiArea from '../services/ApiArea';

import {
    SET_CURRENT_AREA,
    GET_AREAS_START,
    GET_AREAS_ERROR,
    GET_AREAS_SUCCESS,
    ADD_AREA_START,
    ADD_AREA_ERROR,
    ADD_AREA_SUCCESS,
    REMOVE_AREA_ERROR,
    REMOVE_AREA_START,
    REMOVE_AREA_SUCCESS,
    UPDATE_AREA_ERROR,
    UPDATE_AREA_START,
    UPDATE_AREA_SUCCESS,
    GET_AREA_START,
    GET_AREA_ERROR,
    GET_AREA_SUCCESS,
    ADD_AREA_DEVICE_START,
    ADD_AREA_DEVICE_ERROR,
    ADD_AREA_DEVICE_SUCCESS,
    REMOVE_AREA_DEVICE_START,
    REMOVE_AREA_DEVICE_ERROR,
    REMOVE_AREA_DEVICE_SUCCESS,

} from './actionTypes';

export const setCurrentArea = (id) => ({
    type: SET_CURRENT_AREA,
    payload: id,
});

export const getAreas = (id) => ({
    async: true,
    errorType: GET_AREAS_ERROR,
    promise: () => ApiArea.getAreas(id),
    startType: GET_AREAS_START,
    successType: GET_AREAS_SUCCESS,
    type: '',
});

export const addArea = (data) => ({
    async: true,
    errorType: ADD_AREA_ERROR,
    promise: () => ApiArea.addArea(data),
    startType: ADD_AREA_START,
    successType: ADD_AREA_SUCCESS,
    type: '',
});

export const removeArea = (areaId) => ({
    async: true,
    errorType: REMOVE_AREA_ERROR,
    promise: () => ApiArea.removeArea(areaId),
    startType: REMOVE_AREA_START,
    successType: REMOVE_AREA_SUCCESS,
    type: '',
});

export const updateArea = (id, data) => ({
    async: true,
    errorType: UPDATE_AREA_ERROR,
    promise: () => ApiArea.updateArea(id, data),
    startType: UPDATE_AREA_START,
    successType: UPDATE_AREA_SUCCESS,
    type: '',
});

export const getArea = (areaId) => ({
    async: true,
    errorType: GET_AREA_ERROR,
    promise: () => ApiArea.getArea(areaId),
    startType: GET_AREA_START,
    successType: GET_AREA_SUCCESS,
    type: '',
});

export const addAreaDevice = (areaId, deviceId) => ({
    async: true,
    errorType: ADD_AREA_DEVICE_ERROR,
    promise: () => ApiArea.addAreaDevice(areaId, deviceId),
    startType: ADD_AREA_DEVICE_START,
    successType: ADD_AREA_DEVICE_SUCCESS,
    type: '',
});

export const removeAreaDevice = (areaId, deviceId) => ({
    async: true,
    errorType: REMOVE_AREA_DEVICE_ERROR,
    promise: () => ApiArea.removeAreaDevice(areaId, deviceId),
    startType: REMOVE_AREA_DEVICE_START,
    successType: REMOVE_AREA_DEVICE_SUCCESS,
    type: '',
});




// WEBPACK FOOTER //
// ./src/actions/areaActions.js